import emailDragDropConfig from 'EmailEditorUI/redux/inpageSync/emailDragDropConfig';
const emailDragDropSyncConfig = emailDragDropConfig();
class SyncConfigManager {
  constructor(configBuilder) {
    this.configBuilder = configBuilder;
  }
  clear() {
    this.syncConfig = undefined;
  }
  getConfig() {
    if (this.syncConfig === undefined) {
      this.syncConfig = this.configBuilder();
    }
    return this.syncConfig;
  }
}
export { SyncConfigManager as BaseSyncConfigManager };
const emailDragDropSyncConfigManagerInstance = new SyncConfigManager(emailDragDropConfig);
export default emailDragDropSyncConfigManagerInstance;